
import React from 'react';
import { Button as ShadcnButton, ButtonProps as ShadcnButtonProps } from '@/components/ui/button';

export type ButtonProps = ShadcnButtonProps;

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (props, ref) => {
    return <ShadcnButton ref={ref} {...props} />;
  }
);

Button.displayName = 'Button';

export default Button;
